export type Lang = "pt" | "en" | "es";

export const traducoes = {
  pt: {
    hero: {
      title: "Olá, como posso te ajudar?",
      searchAriaLabel: "Buscar na central de ajuda",
      clearTitle: "Limpar",
      clearAriaLabel: "Limpar busca",
      micTitle: "Falar para buscar",
      micAriaLabel: "Usar microfone para buscar por voz",
      searchButton: "Perguntar",
      searchingArticles: "Buscando artigos...",
      articles: "Artigos",
      typeToSee: "Digite para ver tópicos e artigos relacionados.",
    },
    placeholderPhrases: [
      "Não consigo acessar meu curso",
      "Esqueci minha senha",
      "Como cancelar minha assinatura",
      "Como funciona a Mentoria Fluxo",
    ],
    topicPhrases: [
      "Não consigo acessar meu curso",
      "Esqueci minha senha",
      "Como cancelar minha assinatura",
      "Como funciona a Mentoria Fluxo",
      "Certificado",
      "Emitir certificado",
      "Alterar pagamento",
      "Método de pagamento",
      "Vídeo não carrega",
      "Materiais complementares",
      "Cancelar assinatura",
      "Estorno",
      "Privacidade",
      "Contato",
      "Suporte",
      "Acesso à conta",
      "Redefinir senha",
      "Mentoria",
      "Curso",
      "Retiro",
      "Venda Todo Santo Dia",
      "Light Copy",
      "Stories 10x",
      "Master Fluxo",
    ],
    faq: {
      sectionTitle: "Dúvidas frequentes",
      noArticles: "Nenhum artigo publicado ainda.",
      cards: [
        { title: "Como emitir meu certificado?", description: "Aprenda o passo a passo para gerar e baixar seu certificado após a conclusão do curso..." },
        { title: "Esqueci minha senha, e agora?", description: "Siga estas instruções simples para recuperar o acesso à sua conta de forma segura..." },
        { title: "Alterar método de pagamento", description: "Veja como atualizar seu cartão de crédito ou escolher uma forma de pagamento para a sua..." },
        { title: "Vídeo não está carregando", description: "Veja soluções para travamento, buffering ou tela preta durante a exibição dos vídeos..." },
        { title: "Acessar materiais complementares", description: "Você encontrará PDFs, docs e outros arquivos disponíveis para poder te ajudar..." },
        { title: "Como cancelar minha assinatura?", description: "Informações sobre o processo de cancelamento, estorno e políticas de reembolso vigentes." },
      ],
    },
    faqBanner: {
      title: "Ainda não encontrou o que estava procurando?",
      description: "Fale diretamente com nosso time pelo chat e receba suporte personalizado.",
      cta: "Converse com o time",
    },
    trust: {
      title: "Por que a RTG é tão confiável?",
    },
    reclame: {
      fallbackTitle: "SELO ÓTIMO DE REPUTAÇÃO",
      fallbackDescription: "Nossa equipe está sempre pronta para ouvir e resolver qualquer questão.",
      fallbackGreat: "Ótimo",
      imgAlt: "Selo Ótimo de Reputação no Reclame Aqui — Nossa equipe está sempre pronta para ouvir e resolver qualquer questão.",
    },
    gptw: {
      imgAlt: "Great Place To Work — SOMOS GPTW! O orgulho de pertencer nasce no orgulho de ser quem se é por inteiro.",
    },
    verificar: {
      title: "Verifique o número do nosso time",
      description: "Preencha o campo abaixo com o número de whatsapp e valide se faz parte da nossa equipe.",
      placeholder: "(00) 0 0000-0000",
      button: "Verificar Número",
      success: "Este número pertence ao time.",
      error: "Número não encontrado ou inválido. Tente novamente.",
    },
    footer: {
      institucional: "Institucional",
      nossosProdutos: "Nossos Produtos",
      nossosEventos: "Nossos Eventos",
      transparencia: "Transparência",
      institucionalLinks: ["Conheça a RTG", "Parcerias com o Leandro", "Trabalhe com a gente"],
      produtosLinks: ["Venda Todo Santo Dia", "Light Copy", "Stories 10x", "Mentoria Fluxo", "Master Fluxo"],
      eventosLinks: ["Retiro Presencial", "Retiro Escala", "Me dá uma ideia"],
      transparenciaLinks: ["Termos e contratos", "Privacidade"],
      copyright: "© 2026 Ready To Go Education. Todos os direitos reservados. Contato:",
      backToTop: "Voltar ao topo",
    },
  },
  en: {
    hero: {
      title: "Hello, how can I help you?",
      searchAriaLabel: "Search help center",
      clearTitle: "Clear",
      clearAriaLabel: "Clear search",
      micTitle: "Speak to search",
      micAriaLabel: "Use microphone to search by voice",
      searchButton: "Ask",
      searchingArticles: "Searching articles...",
      articles: "Articles",
      typeToSee: "Type to see related topics and articles.",
    },
    placeholderPhrases: [
      "I can't access my course",
      "I forgot my password",
      "How to cancel my subscription",
      "How does Mentoria Fluxo work",
    ],
    topicPhrases: [
      "I can't access my course",
      "I forgot my password",
      "How to cancel my subscription",
      "How does Mentoria Fluxo work",
      "Certificate",
      "Issue certificate",
      "Change payment",
      "Payment method",
      "Video not loading",
      "Supplementary materials",
      "Cancel subscription",
      "Refund",
      "Privacy",
      "Contact",
      "Support",
      "Account access",
      "Reset password",
      "Mentorship",
      "Course",
      "Retreat",
      "Venda Todo Santo Dia",
      "Light Copy",
      "Stories 10x",
      "Master Fluxo",
    ],
    faq: {
      sectionTitle: "Frequently asked questions",
      noArticles: "No articles published yet.",
      cards: [
        { title: "How do I issue my certificate?", description: "Learn the steps to generate and download your certificate after completing the course..." },
        { title: "I forgot my password, what now?", description: "Follow these simple instructions to securely recover access to your account..." },
        { title: "Change payment method", description: "See how to update your credit card or choose a payment method for your subscription..." },
        { title: "Video is not loading", description: "Find solutions for freezing, buffering or black screen during video playback..." },
        { title: "Access supplementary materials", description: "You will find PDFs, docs and other files available to help you..." },
        { title: "How do I cancel my subscription?", description: "Information about the cancellation process, refunds and current refund policies." },
      ],
    },
    faqBanner: {
      title: "Still haven't found what you were looking for?",
      description: "Talk directly to our team via chat and get personalized support.",
      cta: "Chat with the team",
    },
    trust: {
      title: "Why is RTG so trustworthy?",
    },
    reclame: {
      fallbackTitle: "GREAT REPUTATION SEAL",
      fallbackDescription: "Our team is always ready to listen and resolve any issue.",
      fallbackGreat: "Great",
      imgAlt: "Great Reputation Seal on Reclame Aqui — Our team is always ready to listen and resolve any issue.",
    },
    gptw: {
      imgAlt: "Great Place To Work — WE ARE GPTW! The pride of belonging is born from the pride of being who you are.",
    },
    verificar: {
      title: "Verify our team number",
      description: "Fill in the field below with your WhatsApp number and validate if you are part of our team.",
      placeholder: "(00) 0 0000-0000",
      button: "Verify Number",
      success: "This number belongs to the team.",
      error: "Number not found or invalid. Please try again.",
    },
    footer: {
      institucional: "Institutional",
      nossosProdutos: "Our Products",
      nossosEventos: "Our Events",
      transparencia: "Transparency",
      institucionalLinks: ["Meet RTG", "Partnerships with Leandro", "Work with us"],
      produtosLinks: ["Venda Todo Santo Dia", "Light Copy", "Stories 10x", "Mentoria Fluxo", "Master Fluxo"],
      eventosLinks: ["In-person Retreat", "Retreat Escala", "Give me an idea"],
      transparenciaLinks: ["Terms and contracts", "Privacy"],
      copyright: "© 2026 Ready To Go Education. All rights reserved. Contact:",
      backToTop: "Back to top",
    },
  },
  es: {
    hero: {
      title: "Hola, ¿cómo puedo ayudarte?",
      searchAriaLabel: "Buscar en el centro de ayuda",
      clearTitle: "Borrar",
      clearAriaLabel: "Borrar búsqueda",
      micTitle: "Hablar para buscar",
      micAriaLabel: "Usar micrófono para buscar por voz",
      searchButton: "Preguntar",
      searchingArticles: "Buscando artículos...",
      articles: "Artículos",
      typeToSee: "Escribe para ver temas y artículos relacionados.",
    },
    placeholderPhrases: [
      "No puedo acceder a mi curso",
      "Olvidé mi contraseña",
      "Cómo cancelar mi suscripción",
      "Cómo funciona Mentoria Fluxo",
    ],
    topicPhrases: [
      "No puedo acceder a mi curso",
      "Olvidé mi contraseña",
      "Cómo cancelar mi suscripción",
      "Cómo funciona Mentoria Fluxo",
      "Certificado",
      "Emitir certificado",
      "Cambiar pago",
      "Método de pago",
      "El vídeo no carga",
      "Materiales complementarios",
      "Cancelar suscripción",
      "Reembolso",
      "Privacidad",
      "Contacto",
      "Soporte",
      "Acceso a la cuenta",
      "Restablecer contraseña",
      "Mentoría",
      "Curso",
      "Retiro",
      "Venda Todo Santo Dia",
      "Light Copy",
      "Stories 10x",
      "Master Fluxo",
    ],
    faq: {
      sectionTitle: "Preguntas frecuentes",
      noArticles: "Ningún artículo publicado todavía.",
      cards: [
        { title: "¿Cómo emito mi certificado?", description: "Aprende los pasos para generar y descargar tu certificado tras completar el curso..." },
        { title: "Olvidé mi contraseña, ¿y ahora?", description: "Sigue estas instrucciones para recuperar el acceso a tu cuenta de forma segura..." },
        { title: "Cambiar método de pago", description: "Consulta cómo actualizar tu tarjeta o elegir una forma de pago para tu suscripción..." },
        { title: "El vídeo no carga", description: "Soluciones para bloqueos, buffering o pantalla negra durante la reproducción..." },
        { title: "Acceder a materiales complementarios", description: "Encontrarás PDFs, documentos y otros archivos disponibles para ayudarte..." },
        { title: "¿Cómo cancelo mi suscripción?", description: "Información sobre el proceso de cancelación, reembolsos y políticas vigentes." },
      ],
    },
    faqBanner: {
      title: "¿Todavía no encontraste lo que buscabas?",
      description: "Habla directamente con nuestro equipo por chat y recibe soporte personalizado.",
      cta: "Conversa con el equipo",
    },
    trust: {
      title: "¿Por qué RTG es tan confiable?",
    },
    reclame: {
      fallbackTitle: "SELLO DE GRAN REPUTACIÓN",
      fallbackDescription: "Nuestro equipo está siempre listo para escuchar y resolver cualquier cuestión.",
      fallbackGreat: "Genial",
      imgAlt: "Sello de Gran Reputación en Reclame Aqui — Nuestro equipo está siempre listo para escuchar y resolver.",
    },
    gptw: {
      imgAlt: "Great Place To Work — ¡SOMOS GPTW! El orgullo de pertenecer nace del orgullo de ser quien eres.",
    },
    verificar: {
      title: "Verifica el número de nuestro equipo",
      description: "Completa el campo con tu número de WhatsApp y valida si formas parte de nuestro equipo.",
      placeholder: "(00) 0 0000-0000",
      button: "Verificar Número",
      success: "Este número pertenece al equipo.",
      error: "Número no encontrado o inválido. Intenta de nuevo.",
    },
    footer: {
      institucional: "Institucional",
      nossosProdutos: "Nuestros Productos",
      nossosEventos: "Nuestros Eventos",
      transparencia: "Transparencia",
      institucionalLinks: ["Conoce RTG", "Alianzas con Leandro", "Trabaja con nosotros"],
      produtosLinks: ["Venda Todo Santo Dia", "Light Copy", "Stories 10x", "Mentoria Fluxo", "Master Fluxo"],
      eventosLinks: ["Retiro Presencial", "Retiro Escala", "Dame una idea"],
      transparenciaLinks: ["Términos y contratos", "Privacidad"],
      copyright: "© 2026 Ready To Go Education. Todos los derechos reservados. Contacto:",
      backToTop: "Volver arriba",
    },
  },
} as const;

export const speechLangByLocale: Record<Lang, string> = {
  pt: "pt-BR",
  en: "en-US",
  es: "es-ES",
};
